<template>
  <button
    type="button"
    class="base-select-option"
    :class="{ active: isActive }"
    :aria-label="isActive ? $t('shared.selected-option') : $t('shared.option')"
    @click="optionClickHandler(option)"
  >
    <div v-if="hasCheckbox" class="base-select-option__checkbox">
      <checkbox-image v-if="isActive" class="base-select-option__selected" />
    </div>
    <p class="base-select-option__text">{{ optionText }}</p>
  </button>
</template>

<script>
import { isObject } from "@/utils";
import CheckboxImage from "@/assets/images/selected.svg";

export default {
  name: "BaseSelectOption",
  components: {
    CheckboxImage
  },
  props: {
    option: {
      type: [Object, String, Number, Boolean],
      require: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    optionText() {
      return isObject(this.option) ? this.option.name : this.option;
    }
  },
  methods: {
    async optionClickHandler(option) {
      await this.$emit("update-active-option", option);
    }
  }
};
</script>

<style scoped lang="scss">
.base-select-option {
  width: 100%;
  display: flex;
  padding: 12px 0;
  color: $color-grey-400;

  &:hover {
    color: $color-black;
  }

  &.active {
    color: $color-black;

    .base-select-option__checkbox {
      position: relative;
      overflow: hidden;

      .base-select-option__selected {
        position: absolute;
        left: -5px;
        top: -5px;
        transform: scale(.7);
      }
    }
  }
}

.base-select-option__checkbox {
  @include sizing(10px);

  display: inline-block;
  border: 1px solid $color-grey-100;
  margin-right: 9px;
  margin-top: 3px;
}

.base-select-option__text {
  text-align: left;
  margin: 0;
}
</style>
